import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/devop.com-logo.png';

function Navbar() {
  const location = useLocation();

  // Navbar scroll effect
  useEffect(() => {
    const nav = document.getElementById('mainNav');
    const handleScroll = () => {
      if (window.scrollY > 50) {
        nav?.classList.add('scrolled');
      } else {
        nav?.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when a link is clicked
  const closeMenu = () => {
    const collapseEl = document.getElementById('navbarSupportedContent');
    if (collapseEl && collapseEl.classList.contains('show')) {
      const bsCollapse = window.bootstrap?.Collapse.getInstance(collapseEl);
      bsCollapse?.hide();
    }
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <section id="navBar" className="header-section">
      <nav id="mainNav" className="navbar navbar-expand-lg navbar-light py-4 sticky-top">
        <div className="container">

          {/* Logo */}
          <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeMenu}>
            <img src={logo} alt="DDevOps Logo" style={{ height: '3rem' }} />
          </Link>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto align-items-lg-center">

              <li className="nav-item">
                <Link className={`nav-link px-lg-3 ${isActive('/')}`} to="/" onClick={closeMenu}>Home</Link>
              </li>

              <li className="nav-item">
                <Link className={`nav-link px-lg-3 ${isActive('/about')}`} to="/about" onClick={closeMenu}>Company</Link>
              </li>

              {/* Services Dropdown */}
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle px-lg-3" href="#" role="button"
                  data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                  Services
                </a>
                <ul className="dropdown-menu mt-2 shadow-sm">
                  <li><Link className="dropdown-item" to="/devops-services" onClick={closeMenu}>DevOps</Link></li>
                  <li><Link className="dropdown-item" to="/devsecops-services" onClick={closeMenu}>DevSecOps</Link></li>
                  <li><Link className="dropdown-item" to="/managed-services" onClick={closeMenu}>Managed Services</Link></li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className={`nav-link px-lg-3 ${isActive('/development-services')}`} to="/development-services" onClick={closeMenu}>Develop</Link>
              </li>

              {/* Partnership Dropdown */}
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle px-lg-3" href="#" role="button"
                  data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                  Partnership
                </a>
                <ul className="dropdown-menu mt-2 shadow-sm">
                  <li><Link className="dropdown-item" to="/technology-partnership" onClick={closeMenu}>Technology</Link></li>
                  <li><Link className="dropdown-item" to="/whitelabel-solution" onClick={closeMenu}>Whitelabel</Link></li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className={`nav-link px-lg-3 ${isActive('/contact')}`} to="/contact" onClick={closeMenu}>Contact</Link>
              </li>

              <li className="nav-item">
                <a className="nav-link px-lg-3" target="_blank" rel="noreferrer" href="https://blogs.ddevops.com/">Blog</a>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </section>
  );
}

export default Navbar;
